/* ModalWhatsapp.js */

import React, { useCallback, useState } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Strings from '../../translations/Translations';
import { SiWhatsapp } from "react-icons/si";
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import CountryCodes from '../../enums/CountryCodes';
import ReactCountryFlag from 'react-country-flag';

const countryCodesOptions = CountryCodes.map((item) => {
  return {
    value: item.dial_code,
    label: <><ReactCountryFlag svg countryCode={item.code} title={item.code} className='mr-5px' /><span>{item.name}</span></>
  };
});

export default function ModalWhatsapp({ open, setOpen, callback }) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);
  const { register, getValues, reset } = useForm();
  
  const [selectedOption, setSelectedOption] = useState();

  return (
    <Modal isOpen={open} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>
        <SiWhatsapp /> {Strings('add_whatsapp_link')}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={5}>
            <small>{Strings('country')}</small>
            <Select value={selectedOption} onChange={(value) => { setSelectedOption(value); }} options={countryCodesOptions} />
          </Col>
          <Col md={7}>
            <small>{Strings('phone_number')}</small>
            <input className='form-control' {...register('phone_number')}/>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={toggle}>
          {Strings('cancel')}
        </Button>
        <Button
          className='pb-btn-1'
          onClick={() => {
            if (selectedOption && selectedOption.value) {
              let { phone_number } = getValues();
              if (phone_number) {
                phone_number = phone_number.replace(/[^0-9]/g, '');
                let countryCode = selectedOption.value.replace('+', '');
                if (countryCode) {
                  const finalPhoneNumber = `${countryCode}${phone_number}`;
                  if (callback) {
                    callback(finalPhoneNumber);
                    reset();
                    setSelectedOption();
                  }
                }
              }
            }
          }}
        >
          {Strings('add')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
